import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Link, withRouter, useLocation } from "react-router-dom";
import DashboardHeader from "../DashboardHeader";
import { NGNWithdrawalStyle } from "./NGNWithdrawal.styled";
import { P } from "../../../../UI toolkit/Text/Text";
import ic_back_white from "../../../../assets/images/ic-back-white.svg";
import { Card } from "../../../Units/Card.styled";
import { FieldsetInputBase, Input } from "../../../../UI toolkit/Input/Input";
import { withTheme } from "styled-components";
import { connect } from "react-redux";
import { Select } from "../../../../UI toolkit/Dropdown/Dropdown2";
import copyIcon from "../../../../assets/images/copy-icon.svg";
import OTPConfirmationModal from "./OTPConfirmationModal";
import {
  confirmPayoutAction,
  getPayoutBalanceAction,
  getPayoutBanksAction,
  initiatePayoutAction,
  resendPayoutOTPAction,
  verifyPayoutBankAccountAction,
} from "../../../../store/Actions/TransactionActions";
import { formatNumberWithCommas } from "../../../../utils/specialFunctions";
import { DefaultButton } from "../../../../UI toolkit/Button/Button";

const NGNWithdrawal = ({
  crypto,
  loading,
  error,
  theme,
  payoutBanksLoading,
  getBanks,
  payoutBanks,
  payoutAccountBalance,
  getAccountBalance,
  verifyAccountNumber,
  verifiedAccountName,
  initiatePayout,
  confirmPayout,
  resendOtp,
  payoutId,
}) => {
  const location = useLocation();
  const [state, setstate] = useState({
    account_number: "",
    account_name: "",
    bank_list_code: "",
    bank_code: "",
    amount: "",
  });

  const [errorState, setErrorState] = useState({
    account_number: true,
    account_name: true,
    bank_list_code: true,
    bank_code: true,
    amount: true,
  });

  const [triggerError, setTriggerError] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const handleChange = (e) => {
    switch (e.target.type) {
      case "number":
        setstate({
          ...state,
          [e.target.name]: parseFloat(e.target.value),
        });
        setErrorState({
          ...errorState,
          [e.target.name]: false,
        });
        if (e.target.value === "") {
          setErrorState({
            ...errorState,
            [e.target.name]: true,
          });
        }

        break;
      default:
        if (e.target.name === "account_number") {
          if (e.target.value.length > 10 && /^\d*$/.test(e.target.value)) {
            return;
          }
        }
        setstate({
          ...state,
          [e.target.name]: e.target.value,
        });
        setErrorState({
          ...errorState,
          [e.target.name]: false,
        });
        if (e.target.value === "") {
          setErrorState({
            ...errorState,
            [e.target.name]: true,
          });
        }
    }
  };
  const handleSelect = (selected) => {
    console.log("selected", selected);
    setstate({
      ...state,
      bank_code: selected.bank_code,
      bank_list_code: selected.list_code,
    });
    setErrorState({
      ...errorState,
      bank_code: false,
      bank_list_code: false,
    });
  };

  const handleSubmit = async () => {
    setTriggerError(true);
    if (
      !state.account_number ||
      !state.account_name ||
      !state.bank_code ||
      !state.bank_list_code ||
      !state.amount
    ) {
      return;
    }
    console.log("state", state);
    await initiatePayout(state);
    setOpenModal(true);
  };

  useEffect(() => {
    getBanks();
    getAccountBalance();
  }, [getBanks, getAccountBalance]);

  const updateAccountName = async () => {
    console.log("this ran also");
    const res = verifyAccountNumber(state);
    console.log("response", res.data);
  };

  const handleConfirmPayout = async (otp) => {
    await confirmPayout(
      { bani_withdrawal_id: payoutId, otp },
      (response) => {
        if (response) {
          setOpenModal(false);
        }
      }
    );

  };

  const handleResendOtp = async () => {
    await resendOtp({ bani_withdrawal_id: payoutId });
  };

  useEffect(() => {
    console.log("this ran");
    console.log(state.account_number);

    if (
      state.account_number.length === 10 &&
      state.bank_code &&
      state.bank_list_code
    ) {
      updateAccountName();
    }
  }, [state.account_number, state.bank_code, state.bank_list_code]);

  useEffect(() => {
    console.log("this ran");
    console.log(state.account_number);
    setstate({
      ...state,
      account_name: verifiedAccountName,
    });
    setErrorState({
      ...errorState,
      account_name: false,
    });
  }, [verifiedAccountName]);

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>NGN Withdrawal</title>
        <link rel="canonical" href={location.pathname} />
      </Helmet>
      <div>
        <DashboardHeader>Wallet</DashboardHeader>
        <div className="" style={{ display: "flex", justifyContent: "center" }}>
          <NGNWithdrawalStyle width="90%" cryptoBannerBg="#112E46">
            <div className="typeOfCryptoBanner text-center py-4 flex">
              <div className="w-1/12 flex items-center content-center justify-end">
                <Link to="/dashboard/overview" className="">
                  <img src={ic_back_white} alt="back" />
                </Link>
              </div>

              <div className="w-10/12 flex items-center content-center justify-center">
                <P color="#FFF" fontSize="13px">
                  Send
                </P>
              </div>
            </div>
            {/* <pre>{JSON.stringify(payoutBanks, null, 2)}</pre> */}
            {/* <pre>{JSON.stringify(state, null, 2)}</pre>
            <pre>{JSON.stringify(errorState, null, 2)}</pre>
            <pre>{JSON.stringify(payoutId, null, 2)}</pre> */}
            {/* <pre>{JSON.stringify(payoutAccountBalance, null, 2)}</pre> */}
            <Card p={"0"}>
              <div className="py-3 px-8">
                <div className="">
                  <div className="w-full mt-8">
                    <FieldsetInputBase
                      labelColor={"#7A809B"}
                      p={"13px 16px 13px 16px"}
                      border={"1px solid #DEDEDF"}
                      color="#00BFFF"
                      borderColorFocus={"#112E46"}
                      labelColorFocus={"#112E46"}
                      labelBg={"#fff"}
                      labelfontSize={"12px"}
                    >
                      <Input
                        value={state.account_number}
                        type="text"
                        name="account_number"
                        color={"#646A86"}
                        fontWeight="500"
                        border="0px"
                        boxShadow="0px"
                        required
                        maxLength={10}
                        minLength={10}
                        pattern="\d{11}"
                        onChange={handleChange}
                        sideIcon={<img src={copyIcon} />}
                      />

                      <span className="placeholder">
                        {crypto}Account number
                      </span>
                    </FieldsetInputBase>

                    {/* {state.account_number.length < 10 && (
                      <span className="text-sm text-red-400">
                        Account number must be 10 digits
                      </span>
                    )} */}

                    {errorState.account_number && triggerError && (
                      <span className="text-sm text-red-400">
                        Account number is required
                      </span>
                    )}
                  </div>
                  <div className="w-full mt-8">
                    <FieldsetInputBase
                      labelColor={"#7A809B"}
                      p={"13px 16px 13px 16px"}
                      border={"1px solid #DEDEDF"}
                      color="#00BFFF"
                      borderColorFocus={"#112E46"}
                      labelColorFocus={"#112E46"}
                      labelBg={"#fff"}
                      labelfontSize={"12px"}
                    >
                      <Select
                        bgColor={"#fffff"}
                        propertyToShow="bank_name"
                        dropDownbgColor="#E7EAF4"
                        dropDownColor="#7C8191"
                        data={payoutBanks ? payoutBanks : []}
                        onChange={handleSelect}
                      />

                      <span className="placeholder">{crypto}Bank</span>
                    </FieldsetInputBase>

                    {errorState.bank_code &&
                      errorState.bank_list_code &&
                      triggerError && (
                        <span className="text-sm text-red-400">
                          Bank is required
                        </span>
                      )}
                  </div>
                  <div className="w-full mt-8">
                    <FieldsetInputBase
                      labelColor={"#7A809B"}
                      p={"13px 16px 13px 16px"}
                      border={"1px solid #DEDEDF"}
                      color="#00BFFF"
                      borderColorFocus={"#112E46"}
                      labelColorFocus={"#112E46"}
                      labelBg={"#fff"}
                      labelfontSize={"12px"}
                    >
                      <Input
                        value={state.account_name}
                        type="text"
                        name="account_name"
                        color={"#646A86"}
                        fontWeight="500"
                        border="0px"
                        boxShadow="0px"
                        required
                        onChange={handleChange}
                        disabled={true}
                      />

                      <span className="placeholder">{crypto}Account Name</span>
                    </FieldsetInputBase>
                    {errorState.account_name && triggerError && (
                      <span className="text-sm text-red-400">
                        Account name is required
                      </span>
                    )}
                  </div>
                  <div className="w-full mt-8">
                    <FieldsetInputBase
                      labelColor={"#7A809B"}
                      p={"13px 16px 13px 16px"}
                      border={"1px solid #DEDEDF"}
                      color="#00BFFF"
                      borderColorFocus={"#112E46"}
                      labelColorFocus={"#112E46"}
                      labelBg={"#fff"}
                      labelfontSize={"12px"}
                    >
                      <Input
                        value={state.amount}
                        type="number"
                        name="amount"
                        color={"#646A86"}
                        fontWeight="500"
                        border="0px"
                        boxShadow="0px"
                        required
                        onChange={handleChange}
                      />

                      <span className="placeholder">{crypto}Amount</span>
                    </FieldsetInputBase>
                    {errorState.amount && triggerError && (
                      <span className="text-sm text-red-400">
                        Amount is required
                      </span>
                    )}
                  </div>
                  <div
                    style={{
                      background: "#E7EAF4",
                      color: "#7C8191",
                      marginTop: "4px",
                      paddingLeft: "9px",
                    }}
                  >
                    {payoutAccountBalance && (
                      <h2>
                        Balance: ₦{formatNumberWithCommas(payoutAccountBalance)}
                      </h2>
                    )}
                  </div>
                  <div
                    onClick={handleSubmit}
                    className=" flex justify-center bg-primaryBg text-white mt-7 h-12 items-center mb-14"
                  >
                    <h3>Send</h3>
                  </div>
                </div>
              </div>
              {openModal && (
                <div className="flex justify-center">
                  <OTPConfirmationModal
                    width={"27%"}
                    border={"none"}
                    handleResendOtp={handleResendOtp}
                    handleSubmit={handleConfirmPayout}
                    closeModalCallback={() => {
                      setOpenModal(false);
                    }}
                  />
                </div>
              )}
            </Card>
          </NGNWithdrawalStyle>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    payoutBanksLoading: state.transactions.payoutBanksLoading,
    loading: state.transactions.payoutLoading,
    error: state.overview.error,
    payoutBanks: state.transactions.listOfPayoutBanks,
    payoutAccountBalance: state.transactions.payoutAccountBalance,
    verifiedAccountName: state.transactions.verifiedAccountName,
    payoutId: state.transactions.payoutId,
  };
};

// Link Actions to component
const mapDispatchToProps = (dispatch) => {
  return {
    getBanks: () => dispatch(getPayoutBanksAction()),
    getAccountBalance: () => dispatch(getPayoutBalanceAction()),
    verifyAccountNumber: (payload) =>
      dispatch(verifyPayoutBankAccountAction(payload)),
    initiatePayout: (payload) => dispatch(initiatePayoutAction(payload)),
    confirmPayout: (payload, successCallback) =>
      dispatch(confirmPayoutAction(payload, successCallback)),
    resendOtp: (payload) => dispatch(resendPayoutOTPAction(payload)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTheme(NGNWithdrawal)));
